import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { timeout } from '@/utils/common'
import Apis from '@/Apis/_'

type Desconto = {
  nomeDesconto: string,
  valorTotal: number,
}

type GrupoRepasse = {
  idGrupoRepasse: string,
  nomeGrupoRepasse: string,
  valorBrutoTotal: number,
  valorLiquidoTotal: number,
  valorDescontosTotal: number,
  descontos: Desconto[]
}

type GrupoHospital = {
  idGrupoHospital: string,
  nomeGrupoHospital: string,
  valorBrutoTotal: number,
  valorLiquidoTotal: number,
  gruposRepasse: GrupoRepasse[],
}

type RecebimentoHome = {
  mesAnoReferencia: string,
  gruposHospitais: GrupoHospital[],
}

@Module({ namespaced: true, name: 'HomeTransitoriaStore' })
export default class HomeTransitoriaStore extends VuexModule {
  private recebimentosHomeDefault: RecebimentoHome[] = []
  public recebimentosHome: RecebimentoHome[] = [...this.recebimentosHomeDefault]
  public recebimentosTotal: number = 0

  @Mutation
  setRecebimentosTotal(value: GrupoHospital[]) {
    this.recebimentosTotal = 0
    value.forEach((grupo: GrupoHospital) => {
      this.recebimentosTotal += +grupo.valorBrutoTotal
    })
  }

  @Mutation
  clearRecebimentosTotal() {
    this.recebimentosTotal = 0
  }

  @Mutation
  setRecebimentosHome(value: RecebimentoHome[]) {
    this.recebimentosHome = value
  }

  @Mutation
  clearRecebimentosHome() {
    this.recebimentosHome = [...this.recebimentosHomeDefault]
  }

  @Action
  async getAllRecebimentosHome(mesAnoReferencia: string = new Date().toISOString().slice(0, 8).concat('01T00:00:00')) {
    try {
      const request = await Apis.Legacy.RecebimentoApi.getHomeRebimentoByMesReferencia(mesAnoReferencia)
      if (request.success) {
        this.context.commit('setRecebimentosHome', request.data.gruposHospitais as GrupoHospital[] || [])
        this.context.commit('setRecebimentosTotal', request.data.gruposHospitais as GrupoHospital[] || [])
      }
      return request
    } catch (error) {
      this.context.commit('setRecebimentosHome', [])
      this.context.commit('setRecebimentosTotal', [])
      return { success: false, message: 'Ocorreu um erro na requisiçao.' }
    }
  }
}
